import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { addBrand } from "../../services/brand.service";
import { useSelector } from "react-redux";
import Select from "react-select";

export default function BrandAdd() {
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const { token } = useSelector((state) => state?.auth);

  let navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    watch,
    clearErrors,
  } = useForm();

  const onSubmit = async (item) => {
    setIsLoading2(true);

    const data = {
      brand_name: item.brandName,
      image: uploadImage || null,
      description: item.description,
      in_stock: item.inStock,
      acronym: item.acronym,
    };

    try {
      const res = await addBrand(token, data);
      // console.log(res.data.acronym);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Added!",
          text: `${item.brandName} Brand has been added successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
            navigate("/brands");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.acronym?.[0] || "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during adding brand:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };


    const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
          file.type
        )
      ) {
        if (file.size < 1 * 1024 * 1024) {
          setImagePreview(URL.createObjectURL(file));
          setUploadImage(file);
          clearErrors("image");
        } else {
          setError("image", {
            type: "manual",
            message: "Image size must be less than 1MB.",
          });
          setUploadImage(null);
          setImagePreview(null)
          setValue("image", null);
        }
      } else {
        setError("image", {
          type: "manual",
          message: "Only JPEG, PNG, JPG, or WEBP files are allowed.",
        });
        setUploadImage(null);
        setImagePreview(null)
        setValue("image", null);
      }
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Brand</h4>
                <Link to="/brands">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>{" "}
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* Brand Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Brand Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter brand name"
                          {...register("brandName", {
                            required: "Brand name is required",
                          })}
                        />
                        {errors.brandName && (
                          <p className="error">{errors.brandName.message}</p>
                        )}
                      </div>

                      {/* Acronym */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Acronym</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Acronym"
                          {...register("acronym", {
                            required: "Acronym is required",
                          })}
                          maxLength={5}
                        />
                        {errors.acronym && (
                          <p className="error">{errors.acronym.message}</p>
                        )}
                      </div>

                      {/* In Stock */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">In Stock</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <Select
                          options={[
                            { value: "True", label: "Yes" },
                            { value: "False", label: "No" },
                          ]}
                          {...register("inStock", {
                            required: "In stock status is required",
                          })}
                          onChange={(selectedOption) => {
                            setValue("inStock", selectedOption?.value);
                            clearErrors("inStock");
                          }}
                          placeholder="Select Stock Status"
                          isClearable
                          value={[
                            { value: "True", label: "Yes" },
                            { value: "False", label: "No" },
                          ].find((option) => option.value === watch("inStock"))}
                        />
                        {errors.inStock && (
                          <p className="error">{errors.inStock.message}</p>
                        )}
                      </div>

                      {/* Brand Logo */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Brand Logo</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="file"
                          className="form-control"
                          {...register("image", {
                            required: "Brand Logo is required",
                          })}
                          onChange={handleImageChange}
                        />
                        {errors.image && (
                          <p className="error">{errors.image.message}</p>
                        )}
                      </div>
                      <div className="mb-4 col-md-6"></div>
                      <div className="mb-4 col-md-6">
                        {imagePreview && (
                          <img
                            src={imagePreview}
                            alt="Preview"
                            className="img-thumbnail mt-2"
                            style={{ width: "100px" }}
                          />
                        )}
                      </div>

                      {/* Description */}
                      <div className="mb-4 col-md-12">
                        <label className="form-label">Description</label>
                        <textarea
                          rows="3"
                          className="form-control"
                          placeholder="Enter description"
                          {...register("description")}
                        ></textarea>
                        {errors.description && (
                          <p className="error">{errors.description.message}</p>
                        )}
                      </div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          ADD BRAND
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          ADDING BRAND
                        </button>

                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
